import { apiUrlV2 } from "../constants/apiUrl"
import rollbarLogger from "../utilities/rollbarLogger"

const initialState = {
  touches: [],
  isCreatingTouch: false,
  touch: null,
  touchFetching: false
}

const createTouchesSlice = (set, get) => ({
  ...initialState,
  fetchTouches: async (id) => {
    try {
      const response = await fetch(
        `${apiUrlV2}/dealers/${id}/touches`,
        { headers: get().requestHeaders }
      )
      const data = await response.json()
      set(() => ({ touches: data.data }))
    } catch (err) {
      get().logError('Unable to retrieve touches at this time.', err)
    }
  },
  fetchTouch: async (dealerId, id) => {
    set((state) => ({ touchFetching: true}))

    try {
      const response = await fetch(
        `${apiUrlV2}/dealers/${dealerId}/touches/${id}`,
        { headers: get().requestHeaders }
      )
      const data = await response.json()
      set(() => ({ touch: data.data, touchFetching: false }))
    } catch (err) {
      get().logError('Unable to retrieve touch at this time.', err)
    }
  },
  createTouch: async (id, body) => {
    set(() => ({ isCreatingTouch: true }))
    try {
      const response = await fetch(
        `${apiUrlV2}/dealers/${id}/touches`,
        {
          headers: get().requestHeaders,
          method: 'POST',
          body: JSON.stringify(body)
        }
      )
      const data = await response.json()

      if (response.status === 200) {
        get().setSuccessMessage('Touch successfully created')
        get().fetchTouches(id)
      } else {
        get().setErrMessage(data.errors[0])
      }
    } catch (err) {
      get().logError('There was an error creating this touch.', err)
    } finally {
      set(() => ({ isCreatingTouch: false }))
    }
  },
  resetTouchesSlice: () => set(initialState)
})

export default createTouchesSlice